/** Reading the backend's error envelope `{ statusCode, status: 'Error', message }`. */
import { isApiError, type ApiError } from './response';

/** The envelope inside an RTK Query error (`{ status, data }`), if there is one. */
function envelopeOf(error: unknown): ApiError | null {
  if (typeof error !== 'object' || error === null || !('data' in error)) return null;
  return isApiError(error.data) ? error.data : null;
}

/** Human-readable message for any RTK Query error. */
export function apiErrorMessage(
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
): string {
  return envelopeOf(error)?.message ?? fallback;
}

/** The error's HTTP status (`423` vault locked, `410` code expired, …), if the server answered. */
export function apiErrorStatus(error: unknown): number | null {
  return envelopeOf(error)?.statusCode ?? null;
}
